export default {
  methods: {
    mapLayerElectricalSecondaryAdd() {
      this.initPollElectricalSecondary();
      this.map.addSource("electrical-secondary-source", {
        type: "geojson",
        data: this.computedElectricalSecondaryGeoJson
      });

      this.map.addLayer({
        id: "electrical-secondary-fatfinger",
        type: "line",
        source: "electrical-secondary-source",
        paint: {
          "line-color": "Brown",
          "line-width": 22,
          "line-opacity": 0
        }
      });

      this.map.addLayer({
        id: "electrical-secondary",
        type: "line",
        source: "electrical-secondary-source",
        paint: {
          "line-color": "#ff0501",
          "line-width": 2,
          "line-dasharray": [4, 4]
        }
      });

      this.map.addLayer({
        id: "electrical-secondary-hover",
        type: "line",
        source: "electrical-secondary-source",
        paint: {
          "line-color": "Purple",
          "line-width": 10,
          "line-blur": 2
        }
      });

      this.map.moveLayer("electrical-secondary-hover", "marker-layer-lines");
      this.map.moveLayer(
        "electrical-secondary-fatfinger",
        "marker-layer-lines"
      );
      this.map.moveLayer("electrical-secondary", "marker-layer-lines");
    },
    mapLayerElectricalSecondaryRemove() {
      this.cancelPollElectricalSecondary();
      this.map.removeLayer("electrical-secondary-hover");
      this.map.removeLayer("electrical-secondary");
      this.map.removeLayer("electrical-secondary-fatfinger");
      this.map.removeSource("electrical-secondary-source");
    },
    initPollElectricalSecondary() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/electrical/secondary",
        dept: "electrical",
        layer: "secondary",
        token: this.computedAuthToken
      });
      this.pollElectricalSecondaryInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/electrical/secondary",
          dept: "electrical",
          layer: "secondary",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollElectricalSecondary() {
      this.pollElectricalSecondaryInterval = clearInterval(
        this.pollElectricalSecondaryInterval
      );
    }
  },
  computed: {
    computedElectricalSecondaryGeoJson() {
      return this.$store.state.mapLayers.electrical.layers.secondary.geojson;
    },
    computedElectricalSecondaryMapVisibility() {
      return this.$store.state.mapLayers.electrical.layers.secondary.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.electrical.layers.secondary.geojson": {
      handler() {
        if (this.computedElectricalSecondaryGeoJson) {
          this.mapLayerElectricalSecondaryRemove();
          this.mapLayerElectricalSecondaryAdd();
        }
      }
    },
    "$store.state.mapLayers.electrical.layers.secondary.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerElectricalSecondaryAdd();
      } else {
        this.mapLayerElectricalSecondaryRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollElectricalSecondary();
  }
};
